<template>
	<div class="reg_evidence">
		<div class="banner">
			<h1>充值专享优惠 全面保护版权</h1>
			<div class="nav_wrap">
				<div class="nav">
					<div class="chain item " :class="!bookShow? ' ac':''" @click="navClick(0)">
						<div class="pic">
							<img :src="!bookShow? chainImg_ac : chainImg"/>
						</div>
						<p>基于版权区块链的存证</p>
						<span>数据直通互联网法院</span>
					</div>
					<div class="book item " :class="bookShow? ' ac' : ' '" @click="navClick(1)">
						<div class="pic">
							<img :src="bookShow? bookImg_ac : bookImg"/>
						</div>
						<p>作品登记证书</p>
						<span>由国家版权局统一监制，贵州版权局审核下发</span>
					</div>
				</div>
			</div>
		</div>
		<div v-show = "!bookShow">
			<div class="main_wrap">
				<div class="main">
					<div class="content">
						<div class="title">
							<h1>区块链怎么解决传统确权方式</h1>
						</div>
						<div class="item_wrap">
							<div class="item">
								<div class="pic">
									<img src="../../../assets/pen.png"/>
								</div>
								<p>填写复杂表格</p>
							</div>
							<div class="item">
								<div class="pic">
									<img src="../../../assets/evidence_more.png"/>
								</div>
								<p>过程繁琐</p>
							</div>
							<div class="item">
								<div class="pic">
									<img src="../../../assets/more_time.png"/>
								</div>
								<p>耗时耗力</p>
							</div>
							<div class="item ac">
								<div class="pic">
									<img src="../../../assets/light.png"/>
								</div>
								<p>快速、简便</p>
							</div>
							<div class="item ac">
								<div class="pic">
									<img src="../../../assets/flyer.png"/>
								</div>
								<p>没有繁琐过程</p>
							</div>
							<div class="item ac">
								<div class="pic">
									<img src="../../../assets/lowpower.png"/>
								</div>
								<p>具有法律效力</p>
							</div>
							<div class="left_item big_item">
								<div class="pic">
									<img src="../../../assets/evidence_left_s.png"/>
								</div>
								<p>传统的版权存证方式</p>
							</div>
							<div class="centre">
								<div class="pic">
									<img src="../../../assets/qukuailian-.png"/>
								</div>
							</div>
							<div class="right_item big_item">
								<div class="pic">
									<img src="../../../assets/evidence_right_s.png"/>
								</div>
								<p>版权家区块链存证</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="footer">
				<div class="process">
					<div class="title">
						<h1>版权存证服务流程</h1>
					</div>
					<div class="item_wrap">
						<div class="item">
							<div class="piv">
								<img src="../../../assets/process1.png"/>
							</div>
							<p>实名认证</p>
						</div>
						<div class="next">
							<img src="../../../assets/Path.png"/>
						</div>
						<div class="item">
							<div class="piv">
								<img src="../../../assets/works.png"/>
							</div>
							<p>提交作品</p>
						</div>
						<div class="next">
							<img src="../../../assets/Path.png"/>
						</div>
						<div class="item">
							<div class="piv">
								<img src="../../../assets/exam.png"/>
							</div>
							<p>作品审核</p>
						</div>
						<div class="next">
							<img src="../../../assets/Path.png"/>
						</div>
						<div class="item">
							<div class="piv">
								<img src="../../../assets/getBook.png"/>
							</div>
							<p>获取证书</p>
						</div>
					</div>
				</div>
				<div class="loading" style="height:auto">
					<div class="process" style="background:#fff;height:auto">
						<div class="title">
							<h1>充值立享以下优惠</h1>
						</div>
						<ul class="vipTable">
							<Row class="titleType">
								<Col span="12">服务类型</Col>
<!--								<Col span="4">黄金级</Col>-->
								<Col span="4">铂金级</Col>
								<Col span="4">钻石级</Col>
							</Row>
							<Row class="contentTable" v-for="(item,index) in serverTypeArr" :key='index'>
								<Col span="12">
									<span class="con_tit">{{item.title}}</span>
									<span class="con_txt">{{item.desc}}</span>
								</Col>
								<Col v-if="d.grade != '0'" span="4" style="line-height: 87px;" v-for="(d,i) in item.config" :key='i'>{{d.amount}}</Col>
							</Row>
						</ul>
						<Row class="chongzhi_box">
							<Col span="8" class="col" v-for="(item,index) in vipTypeArr" :key='index'>
								<div :style="{backgroundImage: 'url('+item.bg+')',backgroundSize: '100% 100%'}" class="col_content">
									<img :src="item.log"/>
									<p>
										<span class="tit">{{item.desc}}</span>
										<span class="price">¥{{item.amount}}</span>
									</p>
									<button @click="goSy(item)">立即充值</button>
								</div>
							</Col>
						</Row>
					</div>
				</div>
			</div>
		</div>
		<div v-show = "bookShow" class="book">
			<div class="main_wrap">
				<div class="main">
					<div class="content">
						<div class="title">
							<h1>版权登记有哪些优势</h1>
						</div>
						<div class="item_wrap">
							<div class="item">
								<div class="pic">
									<img src="../../../assets/prevent.png"/>
								</div>
								<p>防抄袭</p>
								<span>明确权利归属、依法维权、<br/>打击盗版抄袭。</span>
							</div>
							<div class="item">
								<div class="pic">
									<img src="../../../assets/tgxc.png"/>
								</div>
								<p>提高宣传</p>
								<span>通过登记机构的定期公告，可<br/>以向社会宣传自己的产品</span>
							</div>
							<div class="item">
								<div class="pic">
									<img src="../../../assets/jfss.png"/>
								</div>
								<p>减免税收</p>
								<span>办理高新技术企业认定的前提，<br/>可以享受国家、地方税收减免政策。</span>
							</div>
							<div class="item">
								<div class="pic">
									<img src="../../../assets/hdry.png"/>
								</div>
								<p>获得荣誉</p>
								<span>这是水平的客观反映，国家权<br/>威部门对您能力的认可。</span>
							</div>
							<div class="item">
								<div class="pic">
									<img src="../../../assets/zjzc.png"/>
								</div>
								<p>增加资产</p>
								<span>增加企业或者个人的无形资产，可以<br/>作为增资、融资、抵押技术入股。</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="footer">
				<div class="process">
					<div class="title">
						<h1>版权登记服务流程</h1>
					</div>
					<div class="item_wrap">
						<div class="item">
							<div class="piv">
								<img src="../../../assets/choseWorks.png"/>
							</div>
							<p>选择作品</p>
							<span>从已经获得版权存证<br/>证书的作品中选择适宜作品</span>
						</div>
						<div class="next">
							<img src="../../../assets/Path.png"/>
						</div>
						<div class="item">
							<div class="piv">
								<img src="../../../assets/information.png"/>
							</div>
							<p>完善信息</p>
							<span>完善申请作品登记证书 <br/>所需的创作意图、作品独创性等信息</span>
						</div>
						<div class="next">
							<img src="../../../assets/Path.png"/>
						</div>
						<div class="item">
							<div class="piv">
								<img src="../../../assets/examMsg.png"/>
							</div>
							<p>信息审核</p>
							<span>经版权局<br/>7-10个工作日审核</span>
						</div>
						<div class="next">
							<img src="../../../assets/Path.png"/>
						</div>
						<div class="item">
							<div class="piv">
								<img src="../../../assets/giveBook.png"/>
							</div>
							<p>颁发证书</p>
							<span>审核通过后将获得国家 <br/>版权局颁发的作品登记证书（电子版）</span>
						</div>
					</div>
				</div>
				<div class="loading" style="height:auto">
					<div class="process" style="background:#fff;height:auto">
						<div class="title">
							<h1>充值立享以下优惠</h1>
						</div>
						<ul class="vipTable">
							<Row class="titleType">
								<Col span="12">服务类型</Col>
<!--								<Col span="4">黄金级</Col>-->
								<Col span="4">铂金级</Col>
								<Col span="4">钻石级</Col>
							</Row>
							<Row class="contentTable" v-for="(item,index) in serverTypeArr" :key='index'>
								<Col span="12">
									<span class="con_tit">{{item.title}}</span>
									<span class="con_txt">{{item.desc}}</span>
								</Col>
								<Col span="4" style="line-height: 87px;" v-for="(d,i) in item.config" :key='i'>{{d.amount}}</Col>
							</Row>
						</ul>
						<Row class="chongzhi_box">
							<Col span="8" class="col" v-for="(item,index) in vipTypeArr" :key='index'>
								<div :style="{backgroundImage: 'url('+item.bg+')',backgroundSize: '100% 100%'}" class="col_content">
									<img :src="item.log"/>
									<p>
										<span class="tit">{{item.desc}}</span>
										<span class="price">¥{{item.amount}}</span>
									</p>
									<button @click="goSy(item)">立即充值</button>
								</div>
							</Col>
						</Row>
					</div>
				</div>
			</div>
		</div>
		<vipTypePay :subBizType="subBizTypesb" :payMoney="payMoney" @fatherModal="fatherModal" mywidth='766' myheight="425" myTitleheight="50" v-if="showModal" :grade = 'gradeType'/>
	</div>
</template>

<script>
	import vipTypePay from './lawcomponent/vipTypePay.vue'
    import Cookies from "js-cookie";
    import {goPersonOrEnterVip,getPrecharg} from '@/api/staticPage';
    import { userInfo} from "@/api/index";
	export default {
        data() {
            return {
				serverTypeArr:[],
				vipTypeArr:[],
            	bookShow:true,
            	chainImg:require("../../../assets/chain.png"),
            	chainImg_ac:require("../../../assets/ac_chain.png"),
            	bookImg:require('../../../assets/book.png'),
				bookImg_ac:require('../../../assets/ac_book.png'),
				showModal:!1,
				subBizTypesb:'',
				payMoney:'0',
				gradeType:'',
            }
		},
		components:{
            vipTypePay,
		},
		mounted() {
			this._getPrecharg()
		},
        methods:{
			// 获取系统预充值配置信息
			_getPrecharg(){
				getPrecharg().then(res => {
					if(res.code==200){
            let newVipTypeArr = [];
						for(let i in res.result.gradeList){
              if(res.result.gradeList[i].code == 0){
                res.result.gradeList[i].bg = require("../user/personal/images/hjbj.png");
								res.result.gradeList[i].log = require("../user/personal/images/hjLog.png")
							}
							if(res.result.gradeList[i].code == 1){
								res.result.gradeList[i].bg = require("../user/personal/images/zsBj.png");
								res.result.gradeList[i].log = require("../user/personal/images/zsLog.png")
                newVipTypeArr.push(res.result.gradeList[i])
							}
							if(res.result.gradeList[i].code == 2){
								res.result.gradeList[i].bg = require("../user/personal/images/bjBj.png");
								res.result.gradeList[i].log = require("../user/personal/images/bjLog.png")
                newVipTypeArr.push(res.result.gradeList[i])
							}
						}

            this.serverTypeArr = res.result.serviceList;
						this.vipTypeArr = newVipTypeArr;
					}else{
						toast(res.message)
					}
				}); 
			},
        	navClick(num){
        		this.bookShow = num == 0? false : true
			},
			fatherModal() {
                let _this = this;
                _this.showModal = !1;
            },
			goSy(money){
                let _this = this;
                // _this.getUserStaus();
                /**
                 * 这里原来用_this.getUserStaus，但是，实名认证通过后，第一次获取状态的时候，userInfo()的请求截取不到，第二次就可以了，
                 * 死活找不到原因，ansyc await 也测试了，只能把判断写在获取用户信息里面
                 */
                userInfo().then(res=>{
                    console.log("获取用户状态返回值 ：：：：",res);
                    // debugger

                    if(res.code=="200"){
                        let uInfo = res.result;
                        Cookies.set("userInfo", JSON.stringify(res.result));
                        _this.setStore("userInfo", uInfo );
                        if(uInfo ==''){
                            toast('请登录后再操作')
                            return false;
                        }
                        if(uInfo.realNameStatus != 'complete_real_name'){
                            toast('请实名认证后再操作',function(){
                                _this.$router.push({
                                    path:'/authentication'
                                })
                            })
                            return  false
                        }
						_this.showModal = !0;
						_this.gradeType = money.code
                        // _this.subBizTypesb = money.code
                        _this.payMoney = money.amount
                    }else{
                        toast(res.message);
                    }
                });
            },
        }
   }
</script>

<style scoped="scoped" lang="less">
//充值简介
.vipTable{
	width: 1334px;
	border: 1px solid #E5E5E5;
	margin: auto;
	border-radius: 4px;
	overflow: hidden;
	margin-bottom: 52px;
	.titleType{
		padding-left: 44px;
		box-sizing: border-box;
		height: 68px;
		background: #fff3f4;
		border-radius: 4px 4px 0px 0px;
		font-size: 22px;
		font-weight: 600;
		color: #181818;
		line-height: 68px;
	}
	.contentTable{
		padding-left: 44px;
		box-sizing: border-box;
		height: 87px;
		border-bottom:1px solid #e5e5e5;
		.con_tit{
			font-size: 16px;
			color: #181818;
			line-height: 22px;
			margin:20px 0 8px 0;
			display: block;
		}
		.con_txt{
			line-height: 17px;
			font-size: 12px;
			color: #999999;
			i{
				font-style:inherit;
				color:#FD273A;
			}
		}
	}
	.contentTable:last-child{
		border: none;
	}
}
//充值会员
.chongzhi_box{
	width: 1334px;
	margin: 0 auto 77px;
	.col{
		width: 414px;
		height: 110px;
		box-sizing: border-box;
		padding-right: 45px;
		.col_content{
			width: 100%;
			height: 100%;
		}
		img{
			width: 82px;
			height: 91px;
			float: left;
			margin: 16px 20px 0 34px;
		}
		p{
			float: left;
			.tit{
				display: block;
				font-size: 20px;
				font-weight: 600;
				color: #ffffff;
				line-height: 28px;
				margin: 20px 0 4px 0;
			}
			.price{
				line-height: 45px;
				font-size: 32px;
				font-weight: 600;
				color: #ffffff;
			}
		}
		button{
			width: 102px;
			height: 40px;
			background: #fff;
			border-radius: 21px;
			border: none;
			font-size: 14px;
			color: #181818;
			text-align: center;
			line-height: 40px;
			cursor: pointer;
			outline: none;
			float: right;
			margin-right: 20px;
			margin-top: 35px;
			&:hover{
				background: #ffdc85;
			}
		}
	}
	// .col:last-child{
	// 	padding-right:0px;
	// }
}
	.banner{
		width: 100%;
		height: 262px;
		background-color: rgba(18,18,16,1);
		padding-top: 98px;
		margin-bottom: 300px;
		h1{
			font-size: 40px;
			text-align: center;
			color: #fff;
			margin-bottom: 104px;
		}
		.nav_wrap{
			width: 100%;
			background-color: rgba(18,18,16,1);
			.nav{
				width: 1334px;
				height: 100px;
				margin: 0 auto;
				background-color: #fff;
				.item{
					width: 633px;
					height: 90px;
					background-color: #fff;
					border-bottom: 1px solid rgb(238,238,238);
					float: left;
					padding-top: 16px;
					padding-left: 34px;
					.pic{
						width: 55px;
						height: 59px;
						display: block;
						float: left;
						margin-right: 32px;
					}
					p{
						font-size: 18px;
						color: #121000;
						line-height: 34px;
						margin-bottom: 3px;
					}
					span{
						font-size: 14px;
						color: #121000;
						line-height: 24px;
					}
				}
				.ac{
					border-bottom: 1px solid #E82E31;
				}
			}
		}
	}
	.main_wrap{
		width: 1334px;
		margin: 0 auto;
		.main{
			width: 1023px;
			height: 878px;
			margin: 0 auto;
			background-image: url(../../../assets/main_bc.png);
			.title{
				h1{
					font-size: 46px;
					color: #181818;
					line-height: 144px;
					text-align: center;
				}
			
			}
			.item_wrap{
				position: relative;
				.item{
					/*width: 178px;*/
					height: 64px;
					padding: 8px;
					position: absolute;
					.pic{
						width: 54px;
						height: 54px;
						float: left;
						margin-right: 15px;
						img{
							display: block;
							width: 100%;
							height: 100%;
						}
					}
					p{
						float: left;
						font-size: 20px;
						line-height: 54px;
						color: #666;
					}
				}
				.item:first-child{
					top: 80px;
					left: -60px;
				}
				.item:nth-child(2){
					top: 236px;
					left: -198px;
				}
				.item:nth-child(3){
					top: 380px;
					left: -78px;
				}
				.item:nth-child(4){
					top: 80px;
					right: -26px;
				}
				.item:nth-child(5){
					top: 236px;
					right: -178px;
				}
				.item:nth-child(6){
					top: 380px;
					right: -78px;
				}
				.ac{
					.pic{
						float: right;
						margin-right: 0;
						margin-left: 15px;
					}
					p{
						color: #333;
					}
				}
				.big_item{
					width: 328px/*258px//136px*/;
					height: 182px;
					.pic{
						width: 23px;
						height: 30px;
						margin: 0 auto;
						position: relative;
						top: 60px;
						left: -30px;
						margin-bottom: 21px;
						img{
							display: block;
							width: 100%;
							height: 100%;
						}
					}
					p{
						position: relative;
						top: 60px;
						left: -30px;
						font-size: 16px;
						color: #666;
						text-align: center;
						line-height: 16px;
					}
				}
				.left_item{
					background-image: url(../../../assets/evidence_right.png);
					position: relative;
					top: 182px;
					left: 108px;
				}
				.right_item{
					background-image: url(../../../assets/evidence_left.png);
					position: relative;
					top: 0px;
					left: 584px;
					.pic{
						width: 33px;
						height: 29px;
						left: 30px;
					}
					p{
						left: -24px
					}
				}
				.centre{
					width: 114px;
					height: 114px;
					border-radius: 50%;
					background-color: #E82E31;
					float: left;
					position: relative;
					top: 36px;
					left: 452px;
					.pic{
						width: 55px;
						height: 59px;
						position: absolute;
						top: 28px;
						left: 30px;
						img{
							width: 100%;
							height: 100%;
							display: block;
						}
					}
				}
			}
			
		}
	}
	.footer{
		width: 100%;
		.process{
			width: 100%;
			height: 539px;
			background-color: #F8F8F8;
			.title{
				h1{
					font-size: 42px;
					color: #181818;
					text-align: center;
					line-height: 240px;
				}
			}
			.item_wrap{
				width: 1100px;
				margin: 0 auto;
				.item{
					width: 102px;
					height: 135px;
					float:left;
					.pic{
						width: 102px;
						height: 102px;
						margin-bottom: 17px;
						img{
							display: block;
							width: 100%;
							height: 100%;
							float: left;
						}
					}
					p{
						text-align: center;
						font-size: 16px;
						color: #121210;
						line-height: 44px;
					}
					span{
						display: block;
						float: left;
						width: 170px;
						text-align: center;
						font-size: 14px;
						color: #121000;
						line-height: 24px;
						position: relative;
						left: -34px;
					}
				}
				.next{
					width: 54px;
					height: 36px;
					margin: 0 74px;
					padding-top: 32px;
					float: left;
					img{
						display: block;
						width: 54px;
						height: 36px;
					}
				}
			}
		}
		.loading{
			width: 100%;
			height: 220px;
			background-color: #4861D6;
			background-image: url(../../../assets/evidence_loading.png);
			background-repeat: no-repeat;
			background-position: center;
			h1{
				font-size: 24px;
				color: #fff;
				line-height: 220px;
				text-align: center;
			}
		}
	}
	.book{
		.main{
			height: 1044px;
			background-image: none;
			.item_wrap{
				width: 642px;
				height: 642px;
				margin: 0 auto;
				position: relative;
				background-image: url(../../../assets/book_bc.png);
				.item{
					width: 260px;
					position: absolute;
					.pic{
						width: 80px;
						height: 80px;
						float: none;
						margin: 0;
					}
					p{
						font-size: 18px;
						color: #121000;
						line-height: 50px;
						float: none;
						padding-left: 20px;
					}
					span{
						font-size: 14px;
						color: #121000;
						line-height: 18px;
						text-align: right;
						display: block;
						float: left;
					}
				}
				.item:nth-child(1){
					top: 38px;
					left: 0px;
					span{
						position: absolute;
						left: -100px;
						
					}
				}
				.item:nth-child(2){
					top: 38px;
					left: initial;
					right: -170px;
					p{
						padding: 0;
					}
					span{
						float: left;
						text-align: left;
					}
				}
				.item:nth-child(3){
					top: 346px;
					left: -4px;
					p{
						padding: 0;
					}
					span{
						position: absolute;
						left: -134px;
					}
				}
				.item:nth-child(4){
					top:346px;
					right: -180px;
					p{
						padding: 0;
					}
					span{
						float: left;
						text-align: left;
					}
				}
				.item:nth-child(5){
					top:594px;
					left: 188px;
					.pic{
						margin: 0 auto;
					}
					p{
						padding: 0;
						text-align: center;
						
					}
					span{
						float: none;
						text-align: center;
					}
				}
			}
		}
	}
</style>